import 'firebase/analytics'
import FirebaseManager from '../fronted-share-components/src/utils/firebaseManager.js'

const initialLoginExperience = {
    signin_completed_google: -1,
    get_kv_token_completed: -1,
    get_feature_completed: -1,
    xmpp_signin_completed: -1,
    signin_provider_completed: -2,
    network_type: 'unknown',
    xmpp_type: 'alfred',
    login_type: 'google',
    role: 'camera',
    timeout: 0,
    tls_type: 'websocket',
}

export default class EventManager {
    constructor() {
        this.firebase = FirebaseManager.getInstance()

        this.analytics = this.firebase.analytics()
        this.loginExperienceObj = Object.assign(
            {},
            { ...initialLoginExperience }
        )
        this.loginExperienceTimeout = null
        this.isSentLoginExperience = false
        this.loginStartTime = new Date()
        this.shouldSendLoginExperience = false
    }

    sendSurveyPopupShow() {
        this.firebase.analytics().logEvent('grt_webcamerasurveypopup_showed')
    }
    sendSurveyPopupClickNotNow() {
        this.firebase
            .analytics()
            .logEvent('grt_webcamerasurveypopupnotnow_clicked')
    }
    sendSurveyPopupClose() {
        this.firebase
            .analytics()
            .logEvent('grt_webcamerasurveypopupclose_clicked')
    }
    sendSurveyPopupAnswer() {
        this.firebase
            .analytics()
            .logEvent('grt_webcamerasurveypopupanswer_clicked')
    }
    sendShowRemoteLiveDialog() {
        this.firebase.analytics().logEvent('grt_webcameralivedialog_showed')
    }

    sendClickRemoteLiveDialog() {
        this.firebase.analytics().logEvent('grt_webcameralivedialogok_clicked')
    }

    sendLiveEvent({ uniqueId, isFree, groupId }) {
        this.firebase.analytics().logEvent('camera_live', {
            uniqueId,
            deviceModel: 'Chrome',
            isFree,
            role: 'camera',
            groupId,
        })
    }

    startLogin() {
        this.shouldSendLoginExperience = true
        this.setCountdownLoginExperience()
        this.loginStartTime = new Date()
    }
    setCountdownLoginExperience() {
        this.loginExperienceTimeout = setTimeout(() => {
            if (!this.isSentLoginExperience && this.shouldSendLoginExperience) {
                this.sendLoginExperience(true)
            }
        }, 10000)
    }
    logXmppConnectedTime() {
        this.loginExperienceObj.xmpp_signin_completed =
            new Date().getTime() - this.loginStartTime.getTime()
        this.sendLoginExperience()
    }
    signInComplete() {
        this.loginExperienceObj.signin_completed_google =
            new Date().getTime() - this.loginStartTime.getTime()
    }
    registerDeviceSuccess() {
        this.loginExperienceObj.get_kv_token_completed =
            new Date().getTime() - this.loginStartTime.getTime()
        this.loginExperienceObj.get_feature_completed =
            new Date().getTime() - this.loginStartTime.getTime()
    }

    sendLoginExperience(timeout) {
        if (!this.isSentLoginExperience && this.shouldSendLoginExperience) {
            this.isSentLoginExperience = true
            clearTimeout(this.loginExperienceTimeout)
            this.loginExperienceTimeout = null

            let data = { ...this.loginExperienceObj }
            if (timeout) {
                data.timeout = 1
            }

            data = this.stringifyValue(data)

            this.firebase.analytics().logEvent('login_experience', data)
        }
    }

    sendGrtCameraActive({
        type = 'launch_user',
        is,
        sensitivity,
        xmppOnline,
        lowLight,
        zoomIn,
        enableDetection,
        detectionMode,
    }) {
        const MD_mode = enableDetection
            ? detectionMode === 'motion'
                ? '1'
                : '2'
            : '0'
        const obj = {
            type,
            battery_optimization: '0',
            xmpp_online: xmppOnline ? '1' : '0',
            xmpp_type: '1',
            MD_mode,
            sensitivity: '' + sensitivity,
            MDS: '0',
            notification: '0',
            low_light: lowLight ? '1' : '0',
            zoom_in: zoomIn ? '1' : '0',
        }
        this.firebase.analytics().logEvent('grt_camera_active', obj)
    }

    sendEngagementBehavior(label, action = 'header') {
        const obj = {
            eventCategory: 'webcamera',
            eventAction: action,
            eventLabel: label,
            type: 'click',
            status: 'success',
        }
        this.firebase.analytics().logEvent('engagement_behavior', obj)
    }

    sendFunctionBehavior(label, action) {
        const obj = {
            eventCategory: 'webcamera',
            eventAction: action,
            eventLabel: label,
            type: 'click',
            status: 'success',
        }
        this.firebase.analytics().logEvent('function_behavior', obj)
    }

    sendUserMessage(action) {
        const obj = {
            eventCategory: 'dialog',
            eventAction: action,
            eventLabel: 'display',
        }
        this.firebase.analytics().logEvent('user_message', obj)
    }

    clear() {
        this.loginExperienceObj = Object.assign({}, initialLoginExperience)
        this.loginExperienceTimeout = null
        this.isSentLoginExperience = false
    }

    stringifyValue(obj) {
        let data = JSON.parse(JSON.stringify(obj))
        Object.keys(data).forEach((key) => {
            if (Number.isInteger(data[key])) {
                data[key] = String(data[key])
            }
        })
        return data
    }
}
